import { KITCHEN_GALLERY } from "@/lib/constants";
import RecipeDivider from "./RecipeDivider";

// Masonry-style heights, varied for a handcrafted feel
const heightMap = [
  "h-72",
  "h-96",
  "h-80",
  "h-72",
  "h-96",
  "h-80",
  "h-96",
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="section bg-[hsl(var(--cream-warm))]"
    >
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow">from our kitchen</span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
            A peek at the{" "}
            <span className="font-script text-[hsl(var(--rose-deep))]">
              plates
            </span>{" "}
            we love to serve.
          </h2>
          <p className="mt-4 text-[hsl(var(--brown-soft))]">
            A small gallery from our kitchen — the textures, the colors, the
            quiet little details that make every Heritage Table feel like home.
          </p>
          <div className="mt-6">
            <RecipeDivider />
          </div>
        </div>

        <div
          data-testid="kitchen-gallery-grid"
          className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]"
        >
          {KITCHEN_GALLERY.map((img, i) => (
            <figure
              key={img.id}
              data-testid={`gallery-item-${img.id}`}
              className="recipe-card mb-6 break-inside-avoid overflow-hidden group relative"
              style={{
                animation: `floatin 0.8s ${i * 0.06}s ease-out both`,
              }}
            >
              <div
                className={`relative ${heightMap[i % heightMap.length]} overflow-hidden m-[6px] rounded-[0.95rem]`}
              >
                <img
                  src={img.src}
                  alt={img.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{
                    background:
                      "linear-gradient(180deg, transparent 30%, hsl(28 22% 16% / 0.65) 100%)",
                  }}
                />
                <figcaption className="absolute bottom-4 left-5 right-5 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                  <span
                    className="font-script text-3xl"
                    style={{ color: "hsl(var(--cream))" }}
                  >
                    {img.caption}
                  </span>
                </figcaption>
              </div>
            </figure>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-[hsl(var(--brown-soft))] italic">
          Imagery crafted to capture the spirit of our menus — your event will
          be uniquely yours.
        </p>
      </div>
    </section>
  );
}
